<template>
	<v-card 
		class="text-center mx-auto"
		max-width="400"
		width="100%"
		flat
	>
		<v-card-item>
			<v-card-title :class="titleClass">
				{{ title }}
			</v-card-title>
			<v-card-subtitle :class="subtitleClass">
				{{ subtitle }}
			</v-card-subtitle>
		</v-card-item>

		<v-card-text>
			{{ text }}
		</v-card-text>
		
		<v-card-text>
			<v-form ref="form">
				<v-text-field
					v-model="value"
					label="E-mail"
					placeholder="example@mail.com"
					variant="outlined"
					:rules="[rules.required,rules.email]"
					@keydown.ctrl.z="item.ApplicantEmail='example@mail.com'"
				></v-text-field>
			</v-form>
		</v-card-text>
	</v-card>
</template>

<script>
import mixin from './mixin/main'

export default {
	mixins: [mixin]
}
</script>
